module.exports = __webpack_public_path__ + "img/a68021c.jpg";